import Constants from 'constants.js';
import Dispatcher from 'core/Dispatcher';
// Service
import PerformanceService from 'services/PerformanceService';
// Facade
import Facade from 'core/Facade';
// Actions
import AlertAction from 'actions/AlertAction';
// Locales
import translate from 'locales/i18n';

class PerformanceAction {
    getPerformances(options, bySites) {
        Dispatcher.dispatch({
            actionType: Constants.PERFORMANCES_GET_START,
            value: options
        });

        PerformanceService.getPerformances(options).then(data => {
            Dispatcher.dispatch({
                actionType: Constants.PERFORMANCES_GET_END,
                value: {
                    data: Facade.keysToCamel(data),
                    bySites
                }
            });
        }, response => response && response.error && AlertAction.open('error', translate.i18n(response.error), 'top-right'));
    }

    addPerformance(options) {
        PerformanceService.addPerformance(options).then(data => {
            const newPerformance = options;
            options.id = data.id;

            Dispatcher.dispatch({
                actionType: Constants.PERFORMANCE_ADDED,
                value: newPerformance
            });

            AlertAction.open('success', translate.i18n('SUCCESS_ADD_PERFORMANCE'), 'top-right');
        }, err => {
            AlertAction.open('error', translate.i18n('ERROR_ADD_PERFORMANCE'), 'top-right');
            console.log(err);
        });
    }

    updatePerformance(options, id) {
        PerformanceService.updatePerformance(options, id).then(() => {
            const updatedPerformance = options;
            options.id = id;

            Dispatcher.dispatch({
                actionType: Constants.PERFORMANCE_UPDATED,
                value: updatedPerformance
            });

            AlertAction.open('success', translate.i18n('SUCCESS_UPDATE_PERFORMANCE'), 'top-right');
        }, err => {
            AlertAction.open('error', translate.i18n('ERROR_UPDATE_PERFORMANCE'), 'top-right');
            console.log(err);
        });
    }

    deletePerformance(id) {
        PerformanceService.deletePerformance(id).then(() => {
            Dispatcher.dispatch({
                actionType: Constants.PERFORMANCE_DELETED,
                value: id
            });

            AlertAction.open('success', translate.i18n('SUCCESS_DELETE_PERFORMANCE'), 'top-right');
        }, err => {
            AlertAction.open('error', translate.i18n('ERROR_DELETE_PERFORMANCE'), 'top-right');
            console.log(err);
        });
    }
}

export default new PerformanceAction();
